import { useContext, useEffect } from 'react'
import { EditModeContent, ReportContentCtx } from '../../../../page/context/ReportContentCtx'

export const editModeContentHook = ({
    onEditMode,
    onCancel,
    editMode,
    mode
}: {
    onEditMode: () => void
    onCancel: () => void
    editMode: boolean
    mode: EditModeContent
}) => {
    const { setEditModeContent, editModeContent } = useContext(ReportContentCtx)
    useEffect(() => {
        
        if (typeof setEditModeContent == 'function') {
            if (String(editModeContent) !== String(EditModeContent.PREVIEW)) {
                if (String(editModeContent) === String(mode)) {
                    // onEditMode()
                    // setEditModeContent(mode)
                } else if (editMode) {
                    onCancel()
                }
            } else if (editMode) {             
                // setEditModeContent(mode)
            }            
        }
    }, [editMode, setEditModeContent, editModeContent])

    return editModeContent
}
